import { createFileRoute } from '@tanstack/react-router';

import { exigirMapaAuxiliar } from '@/entities/usuario';
import { MapaProyectosPage } from '@/pages/mapa-proyectos';

export const Route = createFileRoute('/_private/mapa')({
  // Superficie exclusiva del Auxiliar de campo: los demás roles abren el
  // mismo visor desde el detalle de proyecto (proyecto-meta-bar).
  beforeLoad: () => exigirMapaAuxiliar(),
  component: MapaProyectosPage,
});
